module.exports = __webpack_public_path__ + "img/link-expired.e1428119.png";